import { create } from 'zustand'
import Cookies from 'js-cookie'
import { adminState } from '../../admin.service'

type TDecodedJWT = {
    id: number
    sub: string
    exp: number
}

const LOGGED_IN_AT_KEY = 'admin_logged_in_at'
export const useAdminIsLoggedIn = create<boolean>(() => false)

const decodeJwt = (jwt: string) => {
    const tokenDecodablePart = jwt.split('.')[1];
    return JSON.parse(Buffer.from(tokenDecodablePart, 'base64').toString());
};

const adminAuthService = {
    isLoggedIn: () => adminAuthService.getLoggedInAt() !== undefined,
    getLoggedInAt: () => {
        const isLoggedIn = Cookies.get(LOGGED_IN_AT_KEY)
        useAdminIsLoggedIn.setState(isLoggedIn !== undefined)
        return isLoggedIn
    },
    setLoggedIn: () => {
        Cookies.set(LOGGED_IN_AT_KEY, `${Date.now()}`)
        useAdminIsLoggedIn.setState(true)
    },
    removeIsLoggedIn: () => {
        Cookies.remove(LOGGED_IN_AT_KEY)
        useAdminIsLoggedIn.setState(false)
        adminState.setState(null)
    }
}

export default adminAuthService